import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { toTitleCase } from "src/app/core/services/functions.service";
import { isArray, isEmpty, isNotEmpty, isNumber, isString } from "class-validator";


import { MainService } from '../../services/main.service';


@Component({
    selector: 'app-dialog-assing-store',
    templateUrl: './dialog-assing-store.component.html',
    styleUrls: ['./dialog-assing-store.component.scss'],
    // providers: [
    //   { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    // ],
})
export class DialogAssingStoreComponent implements OnInit {
    lengthReferencia: number = 0;
    stores: any
    storesFiltered: any
    title: string = "Asignar Tiendas"
    showFieldAudit = false;
    showFieldInactive = false;
    columns: CokyTableColumn[] = [
        { name: 'C_AGR', title: 'CODIGO' },
        { name: 'NOM', title: 'TIENDA' },
        { name: 'ESTADO', title: 'ESTADO' },

    ]
    inactivos = true
    // page = 1
    // size = 10
    data = []
    user
    dataSource
    selected = new Set<any>();
    displayedColumns: string[] = this.columns.map(value => { return value.name })
    store = ''



    constructor(private mdDialogRef: MatDialogRef<DialogAssingStoreComponent>,
        private mainService: MainService, private commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) data) {
        this.user = data
    }

    async ngOnInit(): Promise<void> {
        showSpinner()
        this.stores = (await this.commonService.findAllStores())['data']
        this.storesFiltered = this.stores
        this.data = (await this.mainService.findStores(this.user["USUARIO"]))['data']
        this.dataSource = new MatTableDataSource<any>(this.data);
        hideSpinner()
        // 
    }
    async close() {
        this.mdDialogRef.close(null);
    }

    async save() {
        showSpinner()
        if (this.showFieldInactive) {
            this.mainService.addStore(this.user["USUARIO"], this.user["N_IDE"], "all")
        }
        else {
            this.mainService.addStore(this.user["USUARIO"], this.user["N_IDE"], this.store["C_AGE"])
        }
        this.mdDialogRef.close("save");
        hideSpinner()



    }
    async changeState(tienda, estado) {
        showSpinner()
        if (estado == "A") {
            this.mainService.editStore(this.user["USUARIO"], tienda, "I").then(res => {
                this.mdDialogRef.close(null);
                hideSpinner()

            })
        }
        else {
            this.mainService.editStore(this.user["USUARIO"], tienda, "A").then(res => {
                this.mdDialogRef.close(null);
                hideSpinner()

            })
        }


    }
    clear() {
        this.store = ''
    }

    // toggleDisable() {
    //     this.showFieldInactive = !this.showFieldAudit;
    //     if (this.showFieldInactive) {
    //         this.form.get('tienda')?.disable();
    //     } else {
    //         this.form.get('tienda')?.enable();
    //     }
    // }

    showAudit(e) {
        console.log("aqui")
        this.showFieldAudit = e
        this.ngOnInit()
    }
    showInactive(e) {
        this.ngOnInit();
    }
    applyFilter(event: Event) {
        // const filterValue = (event.target as HTMLInputElement).value;
        // this.dataSource.filter = filterValue.trim().toLowerCase();

        // if (this.dataSource.paginator) {
        //   this.dataSource.paginator.firstPage();
        // }
    }
    render(item: CokyTableColumn, element: any) {
        item.name = item.name.toLowerCase()
        const el = {}
        for (const key in element) {
            if (Object.prototype.hasOwnProperty.call(element, key)) {
                el[key.toLowerCase()] = element[key]
            }
        }
        // if(isArray(el[item.name])){
        //   // const html=

        // }
        const result = item.render ? item.render(el[item.name], el) :
            (isString(el[item.name]) || isNumber(el[item.name]) || isEmpty(el[item.name]) || isArray(el[item.name]) ? el[item.name] : JSON.stringify(el[item.name]))
        // console.log(result, typeof (result), el)
        if (item.name == 'codigo') {
            // console.log(isNotEmpty(result) ? String(isNaN(Number(result)) ? result : String(result)) : "")
            return isNotEmpty(result) ? String(isNaN(Number(result)) ? result : String(result)) : ""
        }
        else if (item.name == 'codigo_sap') {
            if (el['correo'] == null) {
                return `<center>${el['codigo_sap']} <br> NO EMAIL <center>`
            }
            else {
                return `<center>${el['codigo_sap']} <br> ${el['correo']} <center>`

            }
        }
        else if (item.name == 'modificacion') {
            return `<center> ${el['usuario_mod']} <br> ${el['ult_fecha_mod']} <center>`
        }
        else {
            // console.log(isNotEmpty(result) ? String(isNaN(Number(result)) ? result : Number(result)) : "")
            return isNotEmpty(result) ? String(isNaN(Number(result)) ? result : Number(result)) : ""
        }
    }

    storeFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toUpperCase();
        console.log(filterValue)
        if (!filterValue) {
            this.storesFiltered = this.stores
            return
        }
        this.storesFiltered = this.stores.filter(store => store.C_AGE.includes(filterValue) || store.NOM.toUpperCase().includes(filterValue))

    }

    displayFn(code: any): string {
        return code ? `${code.C_AGE} - ${code.NOM}` : '';
    }

}